import React, { memo } from 'react';
import { withStyles } from '@material-ui/core/styles';
import Slider from '@material-ui/core/Slider';
import Tooltip from '@material-ui/core/Tooltip';
import { colors } from 'global/react-mui/theme/colors';
import FormControl from 'global/react-mui/atoms/FormControl';
import { Box, InputLabel, SliderProps } from '@material-ui/core';
import { INPUT_HEIGHT } from 'global/react-mui/theme/constants';
import { useStyles } from 'global/react-mui/atoms/InputField/styles';
import { FormControlEnhancedProps } from '../FormControl/FormControl';

interface Props {
	children: React.ReactElement;
	open: boolean;
	value: number;
}

function ValueLabelComponent(props: Props) {
	const { children, open, value } = props;

	return (
		<Tooltip open={open} enterTouchDelay={0} placement="top" title={value}>
			{children}
		</Tooltip>
	);
}

const CustomSlider = withStyles({
	root: {
		color: 'primary',
		height: 6,
	},
	thumb: {
		height: 12,
		width: 12,
		backgroundColor: 'primary',
		border: '2px solid currentColor',
		marginTop: -4,
		marginLeft: -12,
		'&:focus, &:hover, &$active': {
			boxShadow: 'inherit',
		},
	},
	active: {},
	valueLabel: {
		left: 'calc(-50% + 4px)',
	},
	track: {
		height: 4,
		borderRadius: 4,
	},
	rail: {
		height: 4,
		borderRadius: 4,
		backgroundColor: colors['silver-grey'],
	},
})(Slider);

type CustomSliderProps = SliderProps & {
	label?: string;
	handleOnChange: (event: any, value: number | number[]) => void;
	hasTooltip?: boolean;
	ariaLabel?: string;
	defaultValue: number;
	formControlProps?: FormControlEnhancedProps;
	id?: string;
};

const CustomizedSlider: React.FC<CustomSliderProps> = ({
	label,
	id,
	ariaLabel,
	hasTooltip,
	defaultValue,
	handleOnChange,
	formControlProps,
	...props
}) => {
	const classes = useStyles();

	const sliderProps = {
		'aria-label': ariaLabel,
		defaultValue: defaultValue,
		ValueLabelComponent: hasTooltip ? ValueLabelComponent : undefined,
		onChange: handleOnChange,
		...props,
	};

	return (
		<FormControl className={classes.root} {...formControlProps}>
			{label && (
				<InputLabel htmlFor={id} shrink style={{ transform: 'translate(0px, 0px) scale(0.75)' }}>
					{label}
				</InputLabel>
			)}
			<Box height={INPUT_HEIGHT} display="flex" alignItems="center">
				<CustomSlider {...sliderProps} />
			</Box>
		</FormControl>
	);
};

export default memo(CustomizedSlider);

CustomizedSlider.defaultProps = {
	hasTooltip: false,
	defaultValue: 20,
};
